import { defineStore } from 'pinia';
import { MarketClassify } from "@/api/market.js"

export const useStockStore = defineStore('stock',{
	state: () => ({
		marketList: uni.getStorageSync('marketList') || []
	}),
	actions:{
		getMarketList(){
			return MarketClassify().then(res => {
				this.marketList = res.result.map(item => {
					return {
						...item,
						label: item.code
					}
				});
				uni.setStorageSync('marketList', this.marketList)
			})
		}
	}
})